import { useEffect, useState } from "react";
import styles from "./roadmap.module.scss";
import { Accordion, Col, Container, Row, Button } from "react-bootstrap";
import falseIcn from "../../../assets/images/falseIcn.svg";
import trueIcn from "../../../assets/images/trueIcn.svg";
import { useDispatch, useSelector } from "react-redux";
import { getRoadmapsListApi } from "../../../lib/store/actions";
import LoaderCstm from "../../../components/Loader";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";

const Roadmap = () => {
  // const { t } = useTranslation();
  const t = useLanguage();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, roadMapsList, totalRoadMaps } = useSelector(
    ({ Tasks, Auth }) => ({
      user: Auth.user,
      loading: Tasks.loading,
      roadMapsList: Tasks.roadMapsList,
      totalRoadMaps: Tasks.totalRoadMaps,
    })
  );
  const [filter, setFilter] = useState({
    page: 1,
    limit: 50,
    order: 1,
    orderBy: "date_created_utc",
    search: "",
    status: "active",
  });
  const [activeKey, setActiveKey] = useState(null);
  useEffect(() => {
    dispatch(getRoadmapsListApi({ data: filter }));
  }, [filter, dispatch]);

  return (
    <>
      <section className={`${styles.roadmap} roadmap position-relataive`}>
        <Container>
          <Row>
            <Col lg="12" className="my-2 no-minimize">
              <div className="top pb-3 text-center position-relative">
                <Button
                  onClick={() => navigate("/game")}
                  className="border-0 p-0 position-absolute "
                  variant="transparent"
                  style={{ top: 0, left: 10 }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="15"
                    viewBox="0 0 14 20"
                    fill="none"
                  >
                    <path
                      d="M2.91436 9.76907L12.1877 2.01034C12.4158 1.81953 12.4158 1.5135 12.1877 1.32268C11.9596 1.13186 11.5939 1.13186 11.3658 1.32268L1.67935 9.42704C1.45128 9.61785 1.45128 9.92388 1.67935 10.1147L11.3658 18.2155C11.4777 18.3091 11.6283 18.3595 11.7746 18.3595C11.9209 18.3595 12.0715 18.3127 12.1834 18.2155C12.4115 18.0246 12.4115 17.7186 12.1834 17.5278L2.91436 9.76907Z"
                      fill="white"
                      stroke="white"
                      stroke-width="2.26051"
                    />
                  </svg>
                </Button>
                <h5 className="m-0 themeClr fw-bold">
                  {t("roadmap_page.title")}
                </h5>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              {loading && filter.page === 1 && <LoaderCstm />}
              {!loading && !roadMapsList?.length ? (
                <div className="d-flex justify-content-center align-items-center">
                  <span>{t("roadmap_page.no_record_found")}</span>
                </div>
              ) : null}
              <Accordion
                defaultActiveKey={activeKey}
                className={`${styles.Accordion} allow-scroll`}
              >
                {roadMapsList?.map((item, key) => {
                  return (
                    <Accordion.Item
                      className={`${styles.accordionItem} my-3 ${
                        (!totalRoadMaps || totalRoadMaps < 5) && !activeKey
                          ? "no-minimize"
                          : ""
                      }`}
                      eventKey={key}
                      key={key}
                      onClick={() =>
                        setActiveKey((preKey) => (preKey === key ? null : key))
                      }
                    >
                      <Accordion.Header className={`${styles.Header}`}>
                        <div
                          className={`${
                            (!totalRoadMaps || totalRoadMaps < 5) && !activeKey
                              ? "no-minimize"
                              : ""
                          }`}
                        >
                          <span className="themeClr fw-bold">
                            {item.quarter} /
                          </span>{" "}
                          {item.title}
                        </div>
                      </Accordion.Header>
                      <Accordion.Body className={`${styles.body}`}>
                        <ul className="list-unstyled ps-0 mb-0">
                          {item.subPoints.map((data, index) => (
                            <li
                              className={`py-1 d-flex align-items-start gap-10 ${
                                (!totalRoadMaps || totalRoadMaps < 5) &&
                                activeKey
                                  ? "no-minimize"
                                  : ""
                              }`}
                            >
                              <span className="icn flex-shrink-0">
                                {data.status === "completed" ? (
                                  <img
                                    src={trueIcn}
                                    alt=""
                                    className="img-fluid"
                                  />
                                ) : (
                                  <img
                                    src={falseIcn}
                                    alt=""
                                    className="img-fluid"
                                  />
                                )}
                              </span>
                              {data.point}
                            </li>
                          ))}
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Roadmap;
